import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SysbizConfig, SysbizConfigService } from './sysbiz-config.service';

export function provideSysbiz(config: SysbizConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SysbizConfigService,
      useValue: config
    }
  ]);
}
